/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: Scroller.tsx
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  05.07.22 9:54 am.
 * Last modified: 05.07.22 9:54 am.
 *
 * More information at: https://egt-digital.com/
 */
import React from 'react';
import { NextScroller, PrevScroller } from '../components/Scroller';

const NavScroller = ({ variant, onClick }: IScrollerProps) => {
    return (
        <div
            className={`egt_lobby_section_${variant === 'left' ? 'leftScroller' : 'rightScroller'} egt_lobby_nav_${
                variant === 'left' ? 'leftScroller' : 'rightScroller'
            }`}
        >
            {variant === 'left' && <PrevScroller onClick={onClick} />}
            {variant === 'right' && <NextScroller onClick={onClick} />}
        </div>
    );
};

interface IScrollerProps {
    variant: 'left' | 'right';
    onClick?: () => void;
}

export default NavScroller;
